export const caseConstants = {
  touchBreakpoint: 999
}
